// Keeping the component for backwards compatibility

type Props = {
  children: React.ReactNode;
};

export default function ThemeLocalization({ children }: Props) {
  // Locale-specific formatting is now handled by browser/i18n directly
  return <>{children}</>;
}
